export enum PaybackLockTypeEnum {
  WITHDRAW_SKIN = 'withdraw-skin',
  WITHDRAW_PAYMENT = 'withdraw-payment',
}
